import { useCallback, useEffect, useState } from 'react';
import type { Event } from '@casetrace/shared';
import { useFocusEventFromSearch } from './use-focus-event-from-search';

/** Kobler ?event=-deep-link til åpning + scroll-komplettering. */
export function useCaseRoomSearchFocus(
  caseId: string,
  eventFromSearch: string | undefined,
  openEvent: (event: Event) => void,
) {
  const [scrolledToEventId, setScrolledToEventId] = useState<string | null>(null);

  useEffect(() => {
    setScrolledToEventId(null);
  }, [eventFromSearch]);

  const { focusEvent } = useFocusEventFromSearch(
    caseId,
    eventFromSearch,
    openEvent,
    scrolledToEventId,
  );

  const onScrolledToEvent = useCallback((eventId: string) => {
    setScrolledToEventId(eventId);
  }, []);

  return {
    focusEvent,
    scrollToEventId: eventFromSearch ?? focusEvent?.id ?? null,
    onScrolledToEvent,
  };
}
